import * as React from 'react';
import { TranslationService } from "../../common";
import { IntelligentAlbumHierarchy } from '../constants';
import { StyledNoPhotosContent, StyledNoPhotosWrapper } from './AlbumHierarchyComponent.style';
/**
 * Render the no content message based on album type
 * @returns {JSX.Element}
 */
export const EmptyAlbumMessageComponent = () => {
    const translateFn = TranslationService.translate;
    return (React.createElement(StyledNoPhotosWrapper, null,
        React.createElement(StyledNoPhotosContent, { id: IntelligentAlbumHierarchy.ID_NO_ATTACHMENT_CONTENT }, translateFn(IntelligentAlbumHierarchy.NO_PHOTOS))));
};
//# sourceMappingURL=EmptyAlbumMessageComponent.js.map